import { useMemo } from 'react';

import styles from './index.module.scss';
import { splitMotto, useTypewriter } from './use-typewriter';

type Props = {
  readonly text: string;
};

// MatchMedia is missing in some embedded webviews (and jsdom); no answer means "animate".
const prefersReducedMotion = () => {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
};

/**
 * The motto, typed phrase by phrase behind a blinking cursor. Screen readers get the whole motto
 * once (the animated text is hidden from them); with reduced motion it simply shows, still.
 */
const TypedMotto = ({ text }: Props) => {
  const phrases = useMemo(() => splitMotto(text), [text]);
  const reduced = useMemo(prefersReducedMotion, []);
  const typed = useTypewriter(phrases, { disabled: reduced });

  return (
    <p className={styles.motto}>
      <span className={styles.srOnly}>{text}</span>
      <span aria-hidden>{typed}</span>
      {!reduced && <span aria-hidden className={styles.cursor} />}
    </p>
  );
};

export default TypedMotto;
